import React from 'react';
import { Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { colorsModeUI } from '../modeUI';

/**
 * Corner icon
 * Show a composition of 2 icons, the second icon is positioned at the corner
 * Parameters (props)
 * @parameter string icon = name of the icon
 * @parameter string color = color of the icon
 * @parameter string iconCorner = name of the icon positioning at the corner
 * @parameter string iconCornerColor = color of the corner icon
 * @parameter string size = size of the icon
 * @parameter string mode
 */
export default class CornerIcon extends React.PureComponent {
  render() {
    const { icon, color, iconCorner, iconCornerColor, size, mode } = this.props;
    let mainIcon = <Icon name={icon} />;
    mainIcon = (
      <mainIcon.type
        {...mainIcon.props}
        {...(color ? { color } : {})}
        {...(size ? { size } : {})}
      />
    );
    const style = {};
    if (mode !== null) {
      const colors = colorsModeUI(mode);
      style.color = colors.TEXT_COLOR;
    }
    let iconCornerDisplay = '';
    if (iconCorner) {
      const styleIconCorner = {};
      if (iconCornerColor) {
        styleIconCorner.color = iconCornerColor;
      }
      iconCornerDisplay = (
        <Icon corner name={iconCorner} style={styleIconCorner} />
      );
    }
    return (
      <Icon.Group style={style}>
        {mainIcon}
        {iconCornerDisplay}
      </Icon.Group>
    );
  }
}

CornerIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  color: PropTypes.string,
  iconCorner: PropTypes.string,
  iconCornerColor: PropTypes.string,
  size: PropTypes.string,
  mode: PropTypes.string,
};

CornerIcon.defaultProps = {
  iconCorner: null,
  color: null,
  iconCornerColor: null,
  size: null,
  mode: null,
};
